import { pathExists } from '@wix/cli-fs';
import {
  getAppBuildFolder,
  getAppManifestPath,
} from '@wix/cli-app-definitions';
import { CliErrorCode, CliError } from '@wix/cli-error';

export async function assertBuildOutputExists(projectFolder: string) {
  const buildFolder = getAppBuildFolder(projectFolder);
  const manifestPath = getAppManifestPath(projectFolder);

  if (!(await pathExists(buildFolder)) || !(await pathExists(manifestPath))) {
    throw new CliError({
      code: CliErrorCode.BuiltProjectNeeded(),
      cause: null,
    });
  }
}
